import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import ErrorBoundaryLayout from "layout/ErrorBoundary";
import "assets/scss/themes.scss";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./store";

const store = configureStore({ reducer: rootReducer, devTools: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <ErrorBoundaryLayout>
        <App />
      </ErrorBoundaryLayout>
    </Provider>
  </BrowserRouter>
);
